

import React from 'react'
import sec5Logo from '../../../../assets/images/sec5_logo.svg'
import Card from '../../../cards/Card'
import AnimationDiv from '../../../animation/AnimationDiv'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'


const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const BlueBgCardView = ({ children, title, propertyData ,loading, toggleWishlist}) => {

    return (
        <div className='mt-24 min-h-96 bg-theme_blue md:p-10  md:rounded-tr-[250px] md:rounded-bl-[250px] rounded-tr-[220px] rounded-bl-[220px] md:sec_5_bg '>
            <div className='py-8 pb-24 md:px-4 mx-[6%]'>
                <div className='flex justify-between flex-wrap-reverse mx-[3%]'>
                    <div>
                        <AnimationDiv
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: true }}
                        >
                            <h2 className='text-[32px] md:text-[55px] lg:text-[4vw] leading-[30px] md:leading-[62px] lg:leading-[82px] text-theme_yellow font-bold my-4 creato-f-b'>
                                Our Exclusive {title} <br className='hidden md:block' />
                                OF THE MONTH!!!
                            </h2>
                        </AnimationDiv>
                        <p className='text-white text-[16px] leading-[27px] md:text-[18px] creato-f-r md:mx-3 max-w-[774px]'>
                            Handpicked properties tailored to your preferences. From modern urban apartments to breathtaking beachfront villas
                        </p>
                    </div>
                    <div>
                        <AnimationDiv
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: true }}
                        >
                            <img src={sec5Logo} alt="" className='max-w-[100px] md:max-w-full' />
                        </AnimationDiv>
                    </div>
                </div>

            <Spin spinning={loading} indicator={<LoadingOutlined spin />}>
                <div className='lg:mt-20 mt-10 grid lg:grid-cols-2 xl:grid-cols-3 md:gap-[44px] max-w-[90%] mx-auto flex-wrap justify-center'>



                    {Array.isArray(propertyData) && propertyData.map(v => (v?.ListingID !== null) && <AnimationDiv
                        key={v.name}
                        className="lg:w-[100%]"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        variants={cardVariants}
                    > <Card data={v} className={`lg:w-[100%] min-w-[300px]`} property_url={true} toggleWishlist={toggleWishlist} /> </AnimationDiv>)}

                </div>
            </Spin>
                {children}

            </div>

        </div>
    )
}

export default BlueBgCardView